<template>
    <b-container id="portal-error" class="portal portal-error mt-5">
        <b-card no-body class="mx-auto text-center">
            <b-card-body>
                <b-card-title v-if="!customError"><h1>Oops!</h1></b-card-title>
                <b-card-text v-if="!customError">
                    <h2 v-if="!errorStatusCode">Something went wrong.</h2>
                    <h2 v-if="errorStatusCode">{{ errorStatusCode + ' - ' + errorStatusText }}</h2>
                    <div class="text-danger mt-4">{{ errorMessage }}</div>

                    <div v-if="portal" class="mt-4 text-center">
                        <div class="text-danger">We're sorry something went wrong with your submission, please contact
                            support.
                        </div>

                        <div class="mt-4">
                            <b-link :href="'mailto:'+ portal.companySupportEmail">
                                {{ portal.companySupportEmail }}
                            </b-link>
                        </div>

                        <b-button v-if="published" squared variant="primary" class="mt-4 text-uppercase"
                                  :to="{ name: 'PortalSubmission', params: { name: portal.name } }">
                            {{ portal.newSubmissionButton ? portal.newSubmissionButton : 'New Submission' }}
                        </b-button>
                        <b-button v-if="!published" squared variant="primary" class="mt-4 text-uppercase"
                                  :to="{ name: 'DraftSubmission', params: { name: portal.name } }">
                            {{ portal.newSubmissionButton ? portal.newSubmissionButton : 'New Submission' }}
                        </b-button>
                    </div>

                    <div v-if="!portal" class="mt-4 text-center">
                        <div class="text-danger">We're sorry something went wrong with your submission, please contact
                            support.
                        </div>

                        <div class="mt-4">
                            <b-link :href="'mailto:support@inpart.io'">support@inpart.io</b-link>
                        </div>
                    </div>
                </b-card-text>
                <b-card-text v-if="customError" v-html="customError">
                </b-card-text>
            </b-card-body>

        </b-card>
    </b-container>
</template>

<script>
    export default {
        name: "Error",
        props: {
            portal: Object,
            errorStatusCode: Number,
            errorStatusText: String,
            errorMessage: String,
            customError: String,
            published: Boolean
        }
    }
</script>

<style scoped>

</style>